import { useParams } from 'react-router';
import { useSchools } from 'src/container/schools';

export function PrivacyPolicy() {
  const { schoolId } = useParams<{ schoolId: string }>();
  const { schoolInfo, privacyPolicyManager, privacyPolicyOrgName, privacyPolicyManagerEmail } = useSchools(+schoolId);

  if (!privacyPolicyManager || !privacyPolicyOrgName || !privacyPolicyManagerEmail) {
    return <div className="p-8 leading-8">개인정보처리방침을 불러올 수 없습니다.</div>;
  }

  return (
    <div className="h-screen overflow-y-auto p-8 leading-8">
      <h1 className={'text-4xl font-bold'}>{schoolInfo?.name}</h1>
      <h2 className={'font-bold'}>개인정보처리방침</h2>
      {schoolInfo?.name}(이하 &#34;학교&#34;)는 통신비밀보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률,
      개인정보보호법 및 정부가 제정한 개인정보보호지침 등 개인정보처리자로서 준수하여야 할 관련 법령상의 개인정보보호
      규정을 준수하며, 주식회사 슈퍼스쿨(이하 &#34;수탁자&#34;)이 제공하는 비대면 학사관리를 위한 통합 솔루션
      서비스(이하 &#34;서비스&#34;)를 이용하여 &#34;학교&#34;의 학사행정 업무를 위탁운영함에 있어, 개인정보처리의
      주체로서 관련 법령에 의거한 개인정보취급방침을 정하여 이용자의 권익 보호에 최선을 다하고 있습니다.
      <br />
      <br />
      <p className={'font-bold'}>1. 수집하는 개인정보/민감정보의 항목 및 수집 방법</p>
      <div className={'pl-6'}>
        <span className={'-ml-5 pr-2'}>1.</span>&#34;학교&#34;는 &#34;서비스&#34;를 이용한 학사행정 업무 수행을 위해
        이용자로부터 아래와 같은 개인정보를 수집하고 있습니다.
        <br />
        <table className={'w-full table-auto border border-slate-400'}>
          <thead className={'border border-slate-400'}>
            <tr>
              <th className={'border border-slate-400'}>수집 및 이용 목적</th>
              <th className={'border border-slate-400'}>수집항목</th>
              <th className={'border border-slate-400'}>보유기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={'border border-slate-400 p-2'}>
                - 본인확인
                <br /> - 회원가입 의사 확인
                <br />
                - 회원가입시 계정의 제공
                <br />
                - &#34;서비스&#34;를 이용한 학사행정 업무 수행
                <br />- &#34;수탁자&#34;를 통해 이용자를 위한 맞춤형 &#34;서비스&#34;를 제공
              </td>
              <td className={'border border-slate-400 p-2'}>
                성명(성과 이름), 생년월일, 주소, 휴대전화 번호, 이메일, 아이디, 비밀번호, 중복가입확인정보(DI), 암호화된
                동일인 식별정보(CI), 시간관리장, 학습 통계자료, 개인 일정표, 성적 및 학업일정 관련 정보
              </td>
              <td rowSpan={3} className={'border border-slate-400 p-2'}>
                &#34;서비스&#34; 마지막 이용일 또는 회원탈퇴 후 1년 또는 법령에 따른 보존 기간
              </td>
            </tr>
            <tr>
              <td className={'border border-slate-400 p-2'}>- 출결관리</td>
              <td className={'border border-slate-400 p-2'}>
                보호자의 성명(성과 이름), 휴대전화 번호, (민감정보) 진료확인서 및 진단서
              </td>
            </tr>
            <tr>
              <td className={'border border-slate-400 p-2'}>- (만 14세 미만인 경우) 법정대리인의 동의 취득</td>
              <td className={'border border-slate-400 p-2'}>
                보호자의 성명(성과 이름), 거주국가, 생년월일, 성별, 휴대전화 번호
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <span className={'-ml-5 pr-2'}>2.</span>&#34;학교&#34;의 &#34;서비스&#34;를 이용한 학사행정 업무 수행 및
        이용자의 &#34;서비스&#34; 이용 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
        <br />
        <table className={'w-full table-auto border border-slate-400'}>
          <thead className={'border border-slate-400'}>
            <tr>
              <th className={'border border-slate-400'}>수집 및 이용 목적</th>
              <th className={'border border-slate-400'}>수집항목</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={'border border-slate-400 p-2'}>
                서비스 부정이용 확인 등 접속관리, 이용자별 사용환경 제공, 활동정보 파악, 이용자 맞춤형 서비스 제공 및
                관리
              </td>
              <td className={'border border-slate-400 p-2'}>쿠키, 서비스 이용기록, 기기 정보, 기기 브라우저 정보</td>
            </tr>
          </tbody>
        </table>
        <br />
        <span className={'-ml-5 pr-2'}>3.</span>&#34;학교&#34;는 &#34;서비스&#34;를 이용한 학사행정 업무 수행에 필요한
        최소한의 개인정보만 수집하며, 이용자의 기본적 인권을 침해할 우려가 있는 민감한 정보(인종, 종교, 사상, 출신지,
        본적지, 정치적 성향 및 범죄기록, 건강상태 등)는 수집하지 않습니다. 다만, 이용자가 수집에 동의하시는 경우는
        예외로 합니다.
        <br />
        <span className={'-ml-5 pr-2'}>4.</span>개인정보 수집 방법&#34;학교&#34;는 다음과 같은 적법하고 공정한 방법으로
        개인정보를 수집합니다.
        <br />
        <p className={'pl-2'}>
          a. 관련 법령에 따른 수집
          <br />
          b. 홈페이지, 어플리케이션, 상담게시판, 이메일, 이벤트 응모 등
          <br />
          c. 생성 정보 수집 툴을 통한 수집
        </p>
      </div>
      <br />
      <p className={'font-bold'}>2. 개인정보 수집 및 이용에 대한 동의</p>
      <div className={'pl-6'}>
        <span className={'-ml-5 pr-2'}>1.</span>관련 법령에 따라 이용자의 개인정보를 수집하는 경우 외에,
        &#34;학교&#34;는 &#34;개인정보 수집 및 이용&#34;에 대한 별도의 동의 획득 절차를 두고, 이용자가 이에 대해
        &#39;동의한다&#39; 또는 &#39;동의하지 않는다&#39; 버튼을 통해 클릭할 수 있는 절차를 마련하고 있습니다.
        &#39;동의한다&#39; 버튼을 클릭하면 개인정보 수집 및 이용에 동의한 것으로 봅니다.
        <br />
        <span className={'-ml-5 pr-2'}>2.</span>이용자는 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며,
        동의를 거부할 경우 받는 별도의 불이익은 없습니다. 단, &#34;학교&#34;의 &#34;서비스&#34;를 이용한 학사행정 업무
        수행이 제한되어 이용자는 다른 방식으로 &#34;학교&#34;로부터 학사행정 업무 제공을 받게 되는 불편함이 따를 수
        있습니다.
      </div>
      <br />
      <p className={'font-bold'}>3. 개인정보/민감정보의 제3자 제공</p>
      &#34;학교&#34;는 관계 법령에 따라 이용자의 동의가 있거나 법률에 특별한 규정이 있는 등의 경우에만 개인정보를
      제3자에게 제공합니다. 이 경우 제2조의 방법을 통해 이용자의 동의를 받습니다.
      <br />
      <br />
      <p className={'font-bold'}>4. 개인정보처리의 위탁</p>
      &#34;학교&#34;는 원활한 학사행정 업무 수행을 위해 &#34;서비스&#34;의 운영 주체인 &#34;수탁자&#34;에게 다음과 같이
      개인정보 처리업무를 위탁하고 있습니다.
      <br />
      <table className={'w-full table-auto border border-slate-400'}>
        <thead className={'border border-slate-400'}>
          <tr>
            <th className={'border border-slate-400'}>위탁받는자</th>
            <th className={'border border-slate-400'}>위탁하는 업무의 내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={'border border-slate-400 p-2'}>주식회사 슈퍼스쿨</td>
            <td rowSpan={3} className={'border border-slate-400 p-2'}>
              &#34;서비스&#34;를 통한 학사행정 업무의 위탁 수행 목적
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <p className={'font-bold'}>5. 개인정보의 보유 및 이용기간</p>
      &#34;학교&#34;는 이용자를 위해 &#34;서비스&#34;를 통해 학사행정 업무를 수행하는 동안 이용자의 개인정보를 보유 및
      이용하며, 이용자가 회원탈퇴를 요청한 경우나 개인정보의 수집 및 이용목적을 달성하거나 보유 및 이용기간이 종료한
      경우 등의 사유가 발생한 경우 해당 정보를 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한
      기간 동안 보존합니다.
      <br />
      <div className={'pl-6'}>
        <span className={'-ml-5 pr-2'}>1.</span>&#34;학교&#34; 내부 방침에 의한 정보 보유 사유
        <br />
        <p className={'pl-5'}>
          <span className={'-ml-5 pr-2'}>a.</span>부정 이용 기록
          <br />
          보존 이유: 부정 이용 방지
          <br />
          보존 기간: 1년
        </p>
        <span className={'-ml-5 pr-2'}>2.</span> 관련 법령에 의한 정보 보유 사유초중등교육법 등 관계 법령의 규정에
        의하여 보존할 필요가 있는 경우 &#34;학교&#34;는 관계 법령에서 정한 일정한 기간 동안 이용자의 정보를 보관합니다.
        이 경우 &#34;학교&#34;는 보관하는 정보를 그 보관의 목적으로만 이용합니다.
        <br />
        <p className={'pl-5'}>
          <span className={'-ml-5 pr-2'}>a.</span>학사행정 업무 수행에 관한 기록
          <br />
          <span className={'-ml-5 pr-2'}>b.</span>본인 확인에 관한 기록
          <br />
          <span className={'-ml-5 pr-2'}>c.</span> 방문에 관한 기록
        </p>
      </div>
      <br />
      <p className={'font-bold'}>6. 개인정보 파기절차 및 방법</p>
      &#34;학교&#34;는 다른 법률에 따라 개인정보를 보존하여야 하는 경우가 아닌 한, 이용자의 개인정보의 수집 및 이용
      목적이 달성되거나, 이용자가 회원탈퇴를 요청한 경우 지체 없이 파기하여 향후 어떠한 용도로도 열람 또는 이용할 수
      없도록 처리합니다. &#34;학교&#34;의 개인정보 파기절치 및 방법은 다음과 같습니다.
      <br />
      <div className={'pl-6'}>
        <span className={'-ml-5 pr-2'}>1.</span>파기절차
        <br />
        목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보 보호
        사유에 따라(5. 보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다. 동 개인정보는 법률에 의한 경우가 아니고
        서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
        <br />
        <span className={'-ml-5 pr-2'}>2.</span>파기방법
        <br />
        종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기하며, 전자적 파일 형태로 저장된 개인정보는 기록을
        재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
      </div>
      <br />
      <p className={'font-bold'}>7. 만 14세 미만 아동의 개인정보 보호</p>
      만14세 미만 아동의 경우 법정대리인(부모님 등)의 동의절차를 거쳐야만 회원 가입 및 아동의 개인정보 수집이
      가능합니다. 만 14세 미만 아동의 법정대리인은 아동의 개인정보의 열람, 정정, 가입해지(동의 철회)를 요청할 수 있으며,
      이러한 요청이 있을 경우 &#34;학교&#34;는 법정대리인 확인 후 지체 없이 필요한 조치를 취합니다. 만14세 미만 아동의
      개인정보도 성인의 개인정보와 동일하게 관리되며, 법정대리인의 동의 없이는 제3자와 공유하지 않습니다.
      <br />
      <br />
      <p className={'font-bold'}>8. 이용자의 권리와 그 행사 방법</p>
      <p>
        이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 동의 철회를 요청할 수도 있습니다.
        이용자의 개인정보 조회, 수정, 동의 철회를 위해서는 &#39;개인정보변경&#39;(또는 &#39;회원정보수정&#39; 등)을
        클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 철회가 가능합니다. 혹은 개인정보관리책임자에게 서면,
        전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다.
      </p>
      <p>
        이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는
        제공하지 않습니다. 또한 만일 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이
        통지하여 정정이 이루어지도록 하겠습니다.&#34;학교&#34;는 이용자 혹은 법정 대리인의 요청에 의해 동의 철회된
        개인정보는 &#34;5. 개인정보의 보유 및 이용기간&#34;에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할
        수 없도록 처리하고 있습니다.
      </p>
      <br />
      <p className={'font-bold'}>9. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</p>
      &#34;학교&#34;는 이용자들에게 특화된 맞춤 서비스를 제공하기 위해서 이용자들의 정보를 저장하고 수시로 불러오는
      &#39;쿠키(cookie)&#39;를 사용합니다. 쿠키는 웹사이트를 운영하는 데 이용되는 서버(HTTP)가 이용자의 컴퓨터
      브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.
      <br />
      <div className={'pl-6'}>
        <span className={'-ml-5 pr-2'}>1.</span>쿠키의 사용 목적이용자들이 방문한 &#34;서비스&#34; 어플리케이션과 웹
        사이트들에 대한 로그인 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위하여 사용합니다.
        <br />
        <span className={'-ml-5 pr-2'}>2.</span>쿠키의 설치/운영 및 거부이용자는 쿠키 설치에 대한 선택권을 가지고
        있습니다. 따라서, 이용자는 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때 마다
        확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.쿠키 설정을 거부하는 방법으로는 이용자가
        사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나 모든
        쿠키의 저장을 거부할 수 있습니다.
        <br />
        설정방법(예: 인터넷 익스플로러의 경우)
        <br />
        : 웹 브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보
        <br />
        다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 일부 &#34;서비스&#34;는 이용에 어려움이 있을 수 있습니다.
      </div>
      <br />
      <p className={'font-bold'}>10. 개인정보의 기술적/관리적 보호 대책</p>
      &#34;학교&#34;는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성
      확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.
      <br />
      <div className={'pl-6'}>
        <span className={'-ml-5 pr-2'}>1.</span>개인정보 암호화이용자의 주요 개인정보는 암호화하여 저장하고 있으며, 파일
        및 전송데이터를 암호화하여 혹시 발생할 수 있는 사고 시라도 이용자의 개인정보가 유출되지 않도록 관리되고
        있습니다.
        <br />
        <span className={'-ml-5 pr-2'}>2.</span>해킹 등에 대비한 대책&#34;학교&#34;는 해킹이나 컴퓨터 바이러스 등에 의해
        이용자의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.개인정보의 훼손에 대비해서 자료를
        수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록
        방지하고 있으며, 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.
        그리고 24시간 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을
        확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.
        <br />
        <span className={'-ml-5 pr-2'}>3.</span>취급 담당자의 최소화 및 교육&#34;학교&#34;의 개인정보관련 취급은 담당자
        및 &#34;수탁자&#34;에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자 및
        &#34;수탁자&#34;에 대한 수시 교육을 통하여 개인정보취급방침의 준수를 항상 강조하고 있습니다. 또한, 이용자의
        개인정보를 취급하기 이전에 보안서약서 등을 통하여 이용자의 개인정보에 대한 정보유출을 사전에 방지하고 관련
        사태규정을 마련하여 이에 대한 이행사항 및 준수 여부를 감시하기 위한 내부절차를 마련하고 있습니다.
        <br />
        <span className={'-ml-5 pr-2'}>4.</span>개인정보보호 전담기구의 운영개인정보보호전담기구 등을 통하여
        개인정보취급방침의 이행사항 및 담당자와 &#34;수탁자&#34;의 준수 여부를 확인하여 문제가 발견될 경우 즉시 수정하고
        바로잡을 수 있도록 노력하고 있습니다.
      </div>
      하지만 근본적으로 개인정보의 보안관리에는 이용자 본인의 노력도 중요합니다. Online 서비스는 오직 아이디와
      비밀번호를 알고 있는 본인에게만 개인 정보에 접근할 수 있는 권한이 있으며, 비밀번호를 유지하고 관리할 책임 역시도
      본인에게 있습니다. 반드시 본인만이 알 수 있는 내용으로 비밀번호를 구성해야 하며, 주민번호의 일부 또는 전화번호 등
      타인이 쉽게 도용할 수 있는 비밀번호의 사용을 지양해야 합니다. 또한 공동으로 사용하는 PC에서 &#34;서비스&#34;에
      접속하여 로그인한 상태에서 다른 사이트로 이동할 경우, 혹은 서비스 이용을 종료하였을 경우에는 반드시 해당
      브라우저를 종료하시기 바랍니다. 그렇지 않을 경우, 해당 브라우저를 통해 아이디, 비밀번호, 주민등록번호가 포함된
      이용자의 개인정보가 타인에게 손쉽게 유출될 위험이 있습니다. 이용자 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호,
      주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 &#34;학교&#34;는 일체의 책임을 지지 않습니다.
      <br />
      <br />
      <p className={'font-bold'}>11. 개인정보 보호책임자 작성</p>
      &#34;학교&#34;는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및
      피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
      <br />
      <p className={'pl-5'}>개인정보 보호책임자</p>
      <p className={'pl-7'}>성명: {privacyPolicyManager}</p>
      <p className={'pl-7'}>소속: {privacyPolicyOrgName}</p>
      <p className={'pl-7'}>
        이메일:&nbsp;<a href={`mailto:${privacyPolicyManagerEmail}`}>{privacyPolicyManagerEmail}</a>
      </p>
      <br />
      귀하께서는 &#34;학교&#34;의 학사행정 업무를 위탁수행하는 &#34;수탁자&#34;의 &#34;서비스&#34;를 이용하시며 발생하는
      모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. &#34;학교&#34;는 이용자들의
      신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
      <br />
      기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
      <br />
      <div className={'pl-6'}>
        <span className={'-ml-5 pr-2'}>-</span>개인정보 보호 종합지원 포털(안전행정부 운영)
        <br />
        www.privacy.go.kr / 02-2100-3343
        <br />
        <span className={'-ml-5 pr-2'}>-</span>개인정보 침해신고센터 (한국인터넷진흥원 운영)
        <br />
        privacy.kisa.or.kr / (국번없이)
        <br />
        <span className={'-ml-5 pr-2'}>-</span>118개인정보보호지원센터 (한국정보화진흥원)
        <br />
        privacy.nia.or.kr / 02-2131-0111
      </div>
      <br />
      <p className={'font-bold'}>12. 고지의 의무</p>
      현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일 전부터 변경이유 및 내용을 홈페이지의
      &#39;공지사항&#39;을 통해 고지할 것입니다. 본 개인정보취급방침의 내용은 수시로 변경될 수 있으므로 사이트를
      방문하실 때마다, 이를 확인하시기 바랍니다.
      <br />
      1. 공고일자: 2022년 3월 2일
      <br />
      2. 시행일자: 2022년 3월 2일
    </div>
  );
}
